import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import * as CatalogActions from "./actions";
import type { ICatalogReducerState } from "./types";

const initialState: ICatalogReducerState = {
  baseCategories: [],
  variantsSelectionSku: null
};

export type CatalogAction = ActionType<typeof CatalogActions>;

export default function catalogReducer(state: ICatalogReducerState = initialState, action: CatalogAction): ICatalogReducerState {
  switch (action.type) {
    case getType(CatalogActions.setBaseCategories):
      return { ...state, baseCategories: action.payload };

    case getType(CatalogActions.showVariantsSelection):
      return { ...state, variantsSelectionSku: action.payload.sku };

    default:
      return state;
  }
}
